import { createFilterOptions } from "@mui/material";
import { useGetManufacturersQuery } from "app/store/manufacturers/api/manufacturersApi";
import { useState } from "react";

const useLeadInformationForm = ({
  leadFormData,
  setLeadFormData,
  setInitialLeads,
}) => {
  const leadInformation = {
    type: "",
    manufacturer: "",
    serial_number: "",
    active: true,
    advisory: false,
  };

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [leadIndexToDelete, setLeadIndexToDelete] = useState();

  const { data: manufacturers } = useGetManufacturersQuery(
    {},
    { refetchOnMountOrArgChange: true }
  );

  const autoCompleteFilter = createFilterOptions();
  const filteredManufacturers = manufacturers?.map(({ name }) => ({
    title: name,
    inputValue: name,
  }));

  const getOptionValue = (option) => {
    return typeof option === "string"
      ? option
      : option?.inputValue || option?.title || option || "";
  };

  const handleInputChange = (index, event, dataKey = undefined) => {
    // for date fields, date value is returned instead of event
    const key = event?.target?.name ?? dataKey;

    // for date fields, date value is returned instead of event
    let value = event?.target?.value ?? event;

    if (
      (key === "active" && value === "") ||
      (key === "advisory" && value === "")
    ) {
      value = false;
    }

    let leadData = [...leadFormData];
    let newLead = { ...leadData[index] };
    newLead[key] = value;
    leadData[index] = newLead;

    setLeadFormData(leadData);
    setInitialLeads(leadData);
  };

  const addLead = () => {
    const newLeadData = { ...leadInformation };

    setLeadFormData([...leadFormData, newLeadData]);
    setInitialLeads([...leadFormData, newLeadData]);
  };

  const getLeadDeleteBodyText = () => {
    const leadToDelete = leadFormData[leadIndexToDelete];

    const confirmDeleteText = `Are you sure you want to delete: ${leadToDelete?.type}?`;
    return confirmDeleteText;
  };

  const deleteLead = (index) => {
    setLeadIndexToDelete(index);
    setShowDeleteModal(true);
  };

  const confirmDelete = (index) => {
    const leadFormDataCopy = [...leadFormData];
    leadFormDataCopy.splice(index, 1);

    setLeadFormData(leadFormDataCopy);
    setInitialLeads(leadFormDataCopy);

    setShowDeleteModal(false);
  };

  return {
    handleInputChange,
    addLead,
    deleteLead,

    showDeleteModal,
    setShowDeleteModal,

    getLeadDeleteBodyText,
    leadIndexToDelete,
    confirmDelete,

    filteredManufacturers,
    getOptionValue,
    autoCompleteFilter,
  };
};

export default useLeadInformationForm;
